import { useEffect } from "react";

import Footer from "../components/Footer";
import Main from "../components/AccountTypes/Main";
import StartTrading from "../components/AccountTypes/StartTrading";
import AccountCards from "../components/AccountTypes/AccountCards";
import ChooseIndividual from "../components/AccountTypes/ChooseIndividual";
import Affiliate from "../components/AccountTypes/Affiliate";

function AccountTypes () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <Main/>
            <AccountCards/>
            <ChooseIndividual/>
            <Affiliate/>
            <StartTrading/>
            <Footer />
        </div>
    );
}

export default AccountTypes;